import IconButton from '@/atoms/IconButton';
import { DialogTitle } from '@radix-ui/react-dialog';
import clx from 'classnames';
import { useTranslation } from 'next-i18next';
import { SIZE } from 'types/utils';
import { ModalHeaderProps } from '../views/types';

const ModalHeader = ({ title, closeModal, subTitle, customTitle, isLoadingContent }: ModalHeaderProps) => {
  const { t } = useTranslation();

  return (
    <DialogTitle className={clx('flex p-6 justify-between items-baseline bg-neutral-100 rounded-sm flex-wrap')}>
      <div>
        {isLoadingContent ? (
          <p className="title-5 text-neutral-900">{t('modal.cms.loading')}</p>
        ) : (
          <>
            {!customTitle && title && <p className="title-5 text-neutral-900">{t(title)}</p>}
            {customTitle}
            {subTitle && <p className="w-full">{subTitle}</p>}
          </>
        )}
      </div>
      {closeModal && <IconButton icon="fa-solid fa-xmark-large" onClick={closeModal} size={SIZE.SM} />}
    </DialogTitle>
  );
};

export default ModalHeader;
